<template lang="pug">
  Accordion.biometric-employee-wrapper(:startOpen="false" @open="loadEmployeeImages")
    template(slot="heading")
      span.fs-19(style="text-align: center;") {{ prettyEmployeeName }} ({{ data.employee.phoneclockPassword }})

    template
      .facial-biometrics(v-if="!loading")
        template(v-if="data.biometrics.length <= 0")
          span Nenhuma foto para mostrar

        template(v-else)
          div(style="margin-top: 8px; font-size: 1.1em;", v-if="approvedPhotos.length > 0")
            span Fotos aprovadas

          .biometric-photos-list(v-if="approvedPhotos.length > 0")
            BiometricCard(
              :data="biometric"
              :empregado="data.employee"
              v-for="biometric in approvedPhotos"
              :key="biometric.id"
              :onClick="removeApprove"
            )

          div(style="margin-top: 8px; font-size: 1.1em;")
            span Todas as fotos

          .biometric-photos-list
            BiometricCard(
              :data="biometric"
              :empregado="data.employee"
              v-for="biometric in notApprovedPhotos"
              :key="biometric.id"
              :onClick="onClickApprove"
            )
      .loading-facial-biometric(v-else)
        .photo(v-for="i in 5")
          SkeletonBox(margin="5px 0 0 10px" key="photoLoading" width="210px" height="280px")
</template>

<script>
import swal from 'sweetalert2'
import VueAccordion from 'src/common/VueAccordion'
import BiometricCard from './BiometricCard'
import { setAmplitudeEvent } from 'src/amplitudeUtils'

export default {
  name: 'biometric-employee-card',
  components: {VueAccordion, BiometricCard},
  props: {
    data: {required: true}
  },
  data () {
    return {
      loading: false,
      alredyLoadImages: false
    }
  },
  computed: {
    approvedPhotos () {
      return this.data.biometrics.filter(biometric => biometric.approved === true)
    },
    notApprovedPhotos () {
      return this.data.biometrics.filter(biometric => biometric.approved === false)
    },
    prettyEmployeeName () {
      if (this.data.employee.code) {
        return `${this.data.employee.code} - ${this.data.employee.name}`
      } else {
        return this.data.employee.name
      }
    }
  },
  methods: {
    async onClickApprove ({id}) {
      try {
        console.log('approving ' + id)
        const result = await this.$API.biometricApprove.save({id}, null)
        console.log(result)
        if (result.ok) {
          this.$store.commit('faceBiometric/changeApproval', {id, approved: true})
          setAmplitudeEvent('salva biometria', {})
        }
      } catch (e) {
        console.log(e)
        swal({ type: 'error', text: e.body ? e.body.error : 'Ocorreu um erro ao aprovar a biometria.' })
      }
    },
    async removeApprove ({id}) {
      try {
        console.log('reproving ' + id)
        const result = await this.$API.biometricApprove.delete({id}, null)
        console.log(result)
        if (result.ok) {
          this.$store.commit('faceBiometric/changeApproval', {id, approved: false})
        }
      } catch (e) {
        console.log(e)
        swal({ type: 'error', text: e.body ? e.body.error : 'Ocorreu um erro ao reprovar a biometria.' })
      }
    },
    async loadEmployeeImages () {
      if (this.alredyLoadImages) return

      this.loading = true

      try {
        await this.$store.dispatch('faceBiometric/loadImagesFromBiometric', {
          employeeId: this.data.employee.id
        })
      } catch (e) {
        console.warn(e)
      } finally {
        this.alredyLoadImages = true
        this.loading = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.biometric-employee-wrapper {
  margin-top: 10px;

  .facial-biometrics {
    .biometric-photos-list {
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
      max-width: 100%;
      overflow-x: overlay;
      padding-bottom: 10px;
    }
  }
  .loading-facial-biometric {
    display: flex;
    .photo {
      display: flex;
      flex-direction: column;
    }
  }
}
</style>
